import { render, staticRenderFns } from "./CarKeyBoard.vue?vue&type=template&id=bef73f76&scoped=true&"
import script from "./CarKeyBoard.vue?vue&type=script&lang=js&"
export * from "./CarKeyBoard.vue?vue&type=script&lang=js&"
import style0 from "./CarKeyBoard.vue?vue&type=style&index=0&id=bef73f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef73f76",
  null
  
)

export default component.exports